import styled from 'styled-components';

export const Section = styled.section`
  & {
    padding: 20px;
  }
`;
